/* Studio 260 Custom Scripts */
document.addEventListener('DOMContentLoaded', function() {
  // Make all Gloss Genius booking links open in a new tab
  document.querySelectorAll('a[href*="glossgenius.com"]').forEach(function(link) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
});
